import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { toCurrency } from 'global/functions';
import moment from 'moment';
import { CloudDownloadOutlined } from '@material-ui/icons';
import { useStyles } from 'service/style';
import * as XLSX from 'xlsx'; // importa o XLSX do CDN

function ExportTable({ processes, lot, totalValue }) {
  const classes = useStyles();

  const handleExport = () => {
    // Sheet 1: Pacote
    const dataSet1 = [
      {
        id: lot.id,
        tracking: lot.tracking_code || 'indefinido',
        totalValue: totalValue || 'indefinido',
      },
    ];
    const ws1 = XLSX.utils.json_to_sheet(dataSet1);
    
    // Sheet 2: Processos
    const dataSet2 = processes.map((p) => ({
      identifier: p.identifier || 'indefinido',
      applicant: p && p.applicant ? p.applicant.name : 'indefinido',
      postalValue:
        p && p.products[0] && p.products[0].postal_value
          ? toCurrency(p.products[0].postal_value / 100, 'EUR')
          : 'indefinido',
    }));
    const ws2 = XLSX.utils.json_to_sheet(dataSet2);

    // Cria workbook e adiciona as sheets
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      ws1,
      `Pacote - ${moment(lot.sent_date).format('MMMM')}`
    );
    XLSX.utils.book_append_sheet(wb, ws2, 'Processos');

    // Nome do arquivo
    const fileName = `Pacote ${
      lot.tracking_code || lot.id
    } - Controle de gastos - ${moment(lot.sent_date).format('MMMM')}.xlsx`;

    // Salva o arquivo
    XLSX.writeFile(wb, fileName);
  };

  return (
    <Button
      variant="contained"
      classes={{
        containedPrimary: classes.alertButton,
      }}
      fullWidth
      color="primary"
      onClick={handleExport}
    >
      {'Baixar .xlsx'}
      <CloudDownloadOutlined fontSize="small" className={classes.iconMargin} />
    </Button>
  );
}

ExportTable.propTypes = {
  processes: PropTypes.array.isRequired,
  lot: PropTypes.object.isRequired,
  totalValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ExportTable;
